var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import config from '@/config';
import api from '@/shared/api';
import { useEffect, useState } from 'react';
var fetchFolders = function (siteId, driveId, folderId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = folderId
                    ? "".concat(config.appUrls.documents, "/api/sharepoint/sites/").concat(siteId, "/drives/").concat(driveId, "/folders/").concat(folderId, "/folders")
                    : "".concat(config.appUrls.documents, "/api/sharepoint/sites/").concat(siteId, "/drives/").concat(driveId, "/folders");
                return [4 /*yield*/, api.base.get(url)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var SharepointFolderTree = function (_a) {
    var siteId = _a.siteId, driveId = _a.driveId, onSelectedFolderChanged = _a.onSelectedFolderChanged, setLoading = _a.setLoading;
    var _b = useState({}), folderCache = _b[0], setFolderCache = _b[1];
    var _c = useState([]), selectedFolders = _c[0], setSelectedFolders = _c[1];
    useEffect(function () {
        setSelectedFolders([]);
    }, [siteId]);
    useEffect(function () {
        setSelectedFolders([]);
        if (!siteId || !driveId) {
            onSelectedFolderChanged('/');
            return;
        }
        if (!folderCache[driveId]) {
            setLoading(true);
            fetchFolders(siteId, driveId).then(function (x) {
                var _a;
                setFolderCache(__assign(__assign({}, folderCache), (_a = {}, _a[driveId] = !x ? [] : x, _a)));
                setLoading(false);
            });
        }
    }, [driveId]);
    useEffect(function () {
        if (!siteId || !driveId) {
            onSelectedFolderChanged('/');
            return;
        }
        var _loop_1 = function (i) {
            var selectedFolder = selectedFolders[i];
            if (selectedFolder === '/')
                return "continue";
            if (!folderCache[selectedFolder]) {
                setLoading(true);
                fetchFolders(siteId, driveId, selectedFolder).then(function (x) {
                    var _a;
                    setFolderCache(__assign(__assign({}, folderCache), (_a = {}, _a[selectedFolder] = x, _a)));
                    setLoading(false);
                });
            }
        };
        for (var i = 0; i < selectedFolders.length; i++) {
            _loop_1(i);
        }
    }, [selectedFolders]);
    if (!siteId || !driveId || !folderCache[driveId])
        return (_jsx("select", __assign({ disabled: true, className: "form-control margin5B" }, { children: _jsx("option", __assign({ value: "/" }, { children: "/" })) })));
    var subfolderSelected = function (folderId, index) {
        var newSelectedFolders = [];
        for (var i = 0; i < index; i++) {
            newSelectedFolders.push(selectedFolders[i]);
        }
        setSelectedFolders(__spreadArray(__spreadArray([], newSelectedFolders, true), [folderId], false));
        onSelectedFolderChanged(folderId);
    };
    var renderSubFolders = function () {
        var _a;
        var items = [];
        var _loop_2 = function (i) {
            var selectedFolder = selectedFolders[i];
            if (selectedFolder === '/' || !((_a = folderCache[selectedFolder]) === null || _a === void 0 ? void 0 : _a.length))
                return "break";
            var item = (_jsxs("select", __assign({ onChange: function (e) { return subfolderSelected(e.target.value, i + 1); }, className: "form-control margin5B" }, { children: [_jsx("option", __assign({ value: "/" }, { children: "/" })), folderCache[selectedFolder].map(function (folder) { return (_jsx("option", __assign({ value: folder.id }, { children: folder.name }), folder.id)); })] }), selectedFolder));
            items.push(item);
        };
        for (var i = 0; i < selectedFolders.length; i++) {
            var state_1 = _loop_2(i);
            if (state_1 === "break")
                break;
        }
        return items;
    };
    return (_jsxs(_Fragment, { children: [_jsxs("select", __assign({ onChange: function (e) { return subfolderSelected(e.target.value, 0); }, className: "form-control margin5B" }, { children: [_jsx("option", __assign({ value: "/" }, { children: "/" })), folderCache[driveId].map(function (folder) { return (_jsx("option", __assign({ value: folder.id }, { children: folder.name }), folder.id)); })] })), renderSubFolders()] }));
};
